import { ServiceHistoryService } from 'api-new/generated';
import { useQuery } from 'react-query';

export const SERVICE_HISTORY_CDK_QUERY_KEY = 'ServiceHistoryCdkQuery';

export const useServiceHistoryCdkQuery = (params: { serviceHistoryId: number }, options?: { enabled?: boolean }) =>
  useQuery(
    [SERVICE_HISTORY_CDK_QUERY_KEY, params.serviceHistoryId],
    () => ServiceHistoryService.getServiceHistoryCdk(params.serviceHistoryId),
    {
      enabled: !!params.serviceHistoryId && options?.enabled !== false
    }
  );
